import { isEscape, returnFocus } from "./app/utils.js";

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}



/*
Imports
*/
import './app/navigation';
import './app/mobile-nav';
import './app/share-dropdown';
import './app/dialog';
import './app/marquee';
import './app/research-nav';
import './app/search';
import './app/tabs';
import './app/mmi-chart';
import './app/mmi-employment-chart';
import './app/mmi-confidence-chart';
import './app/mmi-investment-chart';
import './app/slider';
import './app/stats';

// Redirect when a  select value contains a URL.
$(document).on('change', 'select.topic-change', function () {
    var url = $(this).val();
    console.log(url);
    if (url) {
        window.location.href = url;
    }
});

